import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import csvHelper from '../importjsontocsv';
import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'brandwisestockreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	props: [],
	fields: [],

	data() {
		return {
			limitExeed: false,

			downloadype: '',
			exceedsize: false,
			listMerchantData: [],
			listStockReportData: [],
			listStockReportDatacsv: [],
			listStockReportDataforxls: [],
			dataFilter2: '',
			listStockReportFinalData: [],
			listsubinventoryData: [],
			subinventory: '',
			csvFields: [],
			csvFieldsForXls: {},
			// perPage: 10,
			// pageno: 0,
			// totalPage: 0,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,

			POID: '',
			InvoiceID: '',
			RackID: '',
			ProductID: '',
			merchantname: '',
			fromdate: '',
			todate: '',
			isLoading: false,
			isLoadingforxls: false,
			formattedDate: '',
			reportname: '',
			resultCount: '',
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			stocktype: '',
			stocktypeErr: '',
			user_type: '',
			inventory: 'All',
			userid: '',
			show: false,
			download: true,
			recordLimit: 0,
			exceedFlag: false,
			lesslimitflag: false,
			item: {},
			merchant: '',
			listMerchantData1: [],
			merchantList: [],
			merchantname: '',
			activemrpflag:false,
			isInventoryZone:false,
			zonename:''
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY hh:mm:ss');
		}
	},
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('reports.stockReportBrandWise');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getsubinventoryList();
		this.getMerchantList();
		}
		if(this.clientid!=='undefined' && this.warehouseid!=='undefined'){
			this.getInventoryZonePermission();
		}
		//this.getStockReportData();
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.showSelectWarehouse = true;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getsubinventoryList();
				this.getActiveMrpFlag();
				this.showSelectMerchant = true;
				this.getMerchantList();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantname = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			if(window.localStorage.getItem('selectedWarehouse')!=='undefined'){
			  this.getInventoryZonePermission();
			}
		  });
		this.getRecordLimit()

	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchantname = item.value
		},

		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getStockReportxslData(3)
			}


		},

		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantname = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 			this.getActiveMrpFlag();
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.item = {}
		// 			this.getMerchantList();
		// 			this.getsubinventoryList();
		// 			// this.getStockReportData();
		// 			this.getActiveMrpFlag();
		// 		}
		// 	}
		// 	this.listStockReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getStockReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			this.listMerchantData1 = []
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantlistArray = [];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
						result.data.forEach(function(item) {
							merchantlistArray[item.merchantid] = item.merchantname;

						})
						this.merchantList = merchantlistArray;
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}

				}, error => {
					console.error(error)
				})
		},
		getsubinventoryList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSubInventoryList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listsubinventoryData = result.data;

					}
				}, error => {
					console.error(error)
				})
		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": localStorage.getItem('selectedClient'),
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
	  async getInventoryZonePermission(){
		var userToken = window.localStorage.getItem('userToken')
		var myStr = userToken.replace(/"/g, '');
		this.input=({
			clientid:window.localStorage.getItem("selectedClient"),
			warehouseid:window.localStorage.getItem("selectedWarehouse"),
		})
		const result=await axios({
			method:'POST',
			'url':apiUrl.api_url+'getInventoryZonePermission',
			'data':this.input,
			headers:{
				'Authorization':'Bearer '+myStr
			}
		})
		try{
		   this.isInventoryZone=result.data.inventoryZoneStatus
		}catch(error){
			console.error(error)
		}
	},
		getStockReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getStockReportData(2);
		},
		//to get client list
		getStockReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			this.exceedFlag = false;
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false

			}
			this.searchFlag = true;


			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}

			if (this.stocktype == '') {
				this.stocktypeErr = this.$t('brandwisestock.stockTypeValError');
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}
			this.isLoading = true;
			if (this.fromdate) {
				fr_date = this.dateFormat(this.fromdate)
			}
			if (this.todate) {
				to_date = this.dateFormat(this.todate)
			}
			if (csvCheck == 2)
				this.pageno = 0;

			this.input = ({
				'clientid': localStorage.getItem('selectedClient'),
				'warehouseid': localStorage.getItem('selectedWarehouse'),
				'merchantid': this.merchantname,
				'stocktype': this.stocktype,
				'subinventory': this.subinventory,
				'productid': this.ProductID,
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'csvData': csvCheck,
				userid: this.userid,
				'zonename':this.zonename,
				'isInventoryZone':this.isInventoryZone
			})

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData','isInventoryZone'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'brandWiseStockReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {

							this.listStockReportDataCsv = [];
							this.show = true;
							this.download = false;
							this.csvFields = {
								'clientproductid': this.$t('product.clientProductId'),
								'productname': this.$t('common.productName'),
								'brand': this.$t('common.brand'),
								'mrp': this.$t('common.mrp'),
								'activemrp': this.$t('common.activemrp'),
								'totalqty': this.$t('reports.sumoftotalCSqty'),
								'subinventory': this.$t('reports.inventory'),
								'merchantname': this.$t('common.merchantName'),
								'zonename':this.$t('common.zoneName')

							};
							var dateFilder = [];
							if(this.activemrpflag === true){
                 var skipFilter = ['rowcount'];
							}else {
								var skipFilter = ['rowcount','activemrp'];
							}

							if(this.isInventoryZone===false){
								skipFilter.push('zonename')
							}
							this.listStockReportDataCsv = result.data.data;
							csvHelper.data.jsonToCSV(this.$t('reports.stockReportBrandWise'), this.listStockReportDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						// this.listStockReportDataCsv2 = result.data.data;

						this.listStockReportData = result.data.data;

						if (result.data.errorCode == -1) {
							this.resultCount = 0;
							this.totalRows = 0;
						} else {
							this.totalRows = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count;
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},


		getStockReportxslData(csvCheck = 3) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.searchFlag = true;

			this.show = true;
			this.download = false;

			this.dataFilter2 = [];
			var value = '';
			var str = '';

			if (this.fromdate) {
				fr_date = this.dateFormat(this.fromdate)
			}
			if (this.todate) {
				to_date = this.dateFormat(this.todate)
			}
			if (csvCheck == 2)
				this.pageno = 0;

			this.input = ({
				'clientid': localStorage.getItem('selectedClient'),
				'warehouseid': localStorage.getItem('selectedWarehouse'),
				'merchantid': this.merchantname,
				'stocktype': this.stocktype,
				'subinventory': this.subinventory,
				'productid': this.ProductID,
				'offset': (this.currentPage - 1) * 10,
				'limit': this.pageLimit,
				'csvData': csvCheck,
				userid: this.userid,
				'zonename':this.zonename,
				'isInventoryZone':this.isInventoryZone
			})

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData','isInventoryZone'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'brandWiseStockReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listStockReportDataforxls = [];
							this.csvFieldsForXls[this.$t('product.clientProductId')]='clientproductid';
							this.csvFieldsForXls[this.$t('common.productName')]='productname';
							this.csvFieldsForXls[this.$t('common.brand')]='brand';
							this.csvFieldsForXls[this.$t('common.mrp')]='mrp';
							if(this.activemrpflag === true){
							 this.csvFieldsForXls[this.$t('common.activemrp')]='activemrp';
					   	}
							this.csvFieldsForXls[this.$t('reports.sumoftotalCSqty')]='totalqty';
							this.csvFieldsForXls[ this.$t('reports.inventory')]='subinventory';
							this.csvFieldsForXls[this.$t('common.merchantName')]='merchantname';
							if(this.isInventoryZone ===true){
								this.csvFieldsForXls[this.$t('common.zoneName')]='zonename';
							}
							this.listStockReportDataforxls = result.data.data;
						} else {
							this.listStockReportDataforxls = [];
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}

				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.perPage;
		// 	this.getStockReportData();
		// },

		onPageChange(page) {
			this.currentPage = page;
			this.getStockReportData()
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.POID = '';
			this.InvoiceID = '';
			this.RackID = '';
			this.ProductID = '';
			this.fromdate = '';
			this.todate = '';
			this.merchantname = '',
				this.subinventory = '',
				this.pageno = 0;
			this.totalRows = 0;
			this.stocktype = '';
			this.inventory = 'All';
			this.searchFlag = false;
			this.listStockReportData = [];
			this.item = {}
			this.zonename=''
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
			//this.getStockReportData();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/brandwisestockreport/brandwisestockreport.component.js